import { GuidanceCheckSummary } from 'common/core/approvals/Types';
import { WORKFLOWS } from '.';

/**
 * Generates a GuidanceCheckSummary object with default values set
 * @param defaultValue The default value to set for each target audience attribute
 * @returns A default GuidanceCheckSummary Object
 */
export const createDefaultGuidanceCheckSummary = <T>(defaultValue: T): GuidanceCheckSummary<T> => {
  const response = {
    length: 0,
    totalWorkflows: WORKFLOWS.length,
  } as GuidanceCheckSummary<T>;

  WORKFLOWS.forEach((targetAudience) => (response[targetAudience] = defaultValue));

  return response;
};

export default createDefaultGuidanceCheckSummary;
